
import { Component, Vue } from 'nuxt-property-decorator'

@Component({
  middleware: ['auth'],
})
export default class extends Vue {}
